import { render } from "./DataTableFooter.vue?vue&type=template&id=2688bf58"
import script from "./DataTableFooter.vue?vue&type=script&lang=js"
export * from "./DataTableFooter.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DataTableFooter.vue?vue&type=style&index=0&id=2688bf58&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__